module.exports = __webpack_public_path__ + "img/hypebot.5729902f.png";